var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3905 10.5129C20.3992 10.5129 20.4079 10.5128 20.4167 10.5128C23.3162 10.5128 25.6667 12.8676 25.6667 15.7725C25.6667 18.4798 23.625 20.7093 21 21M20.3905 10.5129C20.4078 10.3204 20.4167 10.1255 20.4167 9.92844C20.4167 6.37811 17.5439 3.5 14 3.5C10.6438 3.5 7.8894 6.08145 7.60717 9.37057M20.3905 10.5129C20.2712 11.8389 19.75 13.0487 18.9499 14.0193M7.60717 9.37057C4.64799 9.65269 2.33334 12.1495 2.33334 15.188C2.33334 18.0153 4.3374 20.3737 7.00001 20.9152M7.60717 9.37057C7.79131 9.35302 7.97795 9.34403 8.16668 9.34403C9.48013 9.34403 10.6922 9.77893 11.6673 10.5128",
    stroke: "#161E21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.4998V15.1665M14 24.4998C13.1831 24.4998 11.6568 22.1732 11.0833 21.5832M14 24.4998C14.8169 24.4998 16.3433 22.1732 16.9167 21.5832",
    stroke: "#161E21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadApp);
export default __webpack_public_path__ + "static/media/DownloadApp.d0fc143eda3ce4ed10570f34963466f0.svg";
export { ForwardRef as ReactComponent };